import React, { useState } from "react";
import {
  Drawer,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WorkshopAdminDrawerContent from "./WorkshopAdminDrawerContent";

const drawerWidth = 240;

interface WorkshopAdminDrawerProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

const WorkshopAdminDrawer: React.FC<WorkshopAdminDrawerProps> = ({
  mobileOpen = false,
  onMobileClose,
}) => {
  const [open, setOpen] = useState(true); // Desktop drawer state
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobile) {
    // MOBILE MODE: Temporary Drawer
    return (
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true, // Better performance on mobile
        }}
        sx={{
          display: { xs: "block", md: "none" },
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: "#fafafa",
            borderRight: "1px solid #f0f0f0",
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
          },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
          <IconButton onClick={onMobileClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <WorkshopAdminDrawerContent />
      </Drawer>
    );
  }

  // DESKTOP MODE: Persistent Drawer
  return (
    <Drawer
      variant="persistent"
      open={open}
      sx={{
        width: open ? drawerWidth : 0,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: drawerWidth,
          boxSizing: "border-box",
          transition: "width 0.3s",
          overflowX: "hidden",
          backgroundColor: "#fafafa",
          borderRight: "1px solid #f0f0f0",
          boxShadow:
            "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
        },
      }}
    >
      <WorkshopAdminDrawerContent />
    </Drawer>
  );
};

export default WorkshopAdminDrawer;
